import { render, staticRenderFns } from "./biochemical.vue?vue&type=template&id=e140472a&scoped=true&"
import script from "./biochemical.vue?vue&type=script&lang=js&"
export * from "./biochemical.vue?vue&type=script&lang=js&"
import style0 from "./biochemical.vue?vue&type=style&index=0&id=e140472a&scoped=true&lang=css&"
import style1 from "./biochemical.vue?vue&type=style&index=1&id=e140472a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e140472a",
  null
  
)

export default component.exports